export default __webpack_public_path__ + "static/themepublish-ce512c4d3628ac673718076bd4bbb2ec.png";